const PERMISSIONS = {
DEPLOYMENTS: {
VIEW_CLUSTERS: 'view-clusters',
MANAGE_CLUSTERS: 'manage-clusters',
},

ORGANIZATIONS: {
VIEW_ORGANIZATIONS: 'view-organizations',
MANAGE_ORGANIZATIONS: 'manage-organizations',
VIEW_MEMBERS: 'view-members',
MANAGE_MEMBERS: 'manage-members',
},
ADMINISTRATION:{
    ADMINISTRATOR_ROLE: "aswar-admin",
}
};

export default PERMISSIONS;